/**
 * Validates that all of the specified values are present.
 */
export const Validator = {
    name: "required_all",
    isImplicit: true,
    errorMessage: "You should select all options above.",
    validate: (value, requirement) => {
        if (typeof value !== "string") {
            return false;
        }
        const values = value.split(":");
        return requirement
            .split(",")
            .every(requiredVal => values.includes(requiredVal));
    },
};
